import { CommonModule } from '@angular/common';
import { Component, Input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';

@Component({
  selector: 'app-modal-header',
  imports: [CommonModule, TranslateModule, NickyButtonComponent, MatIconModule],
  templateUrl: './modal-header.component.html',
})
export class ModalHeaderComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() hasTour: boolean = false;
  @Input() showCloseIcon: boolean = true;

  close = output();
  tour = output();

  onClose(): void {
    this.close.emit();
  }

  onTour(): void {
    this.tour.emit();
  }
}
